<script setup lang="ts">
import { onMounted, ref } from 'vue'
import LoadingButton from '@/components/app/LoadingButton.vue'
import CodeField from '@/components/app/CodeField.vue'
import ErrorAlert from '@/components/app/ErrorAlert.vue'

/** Saisie du code OTP e-mail — l'envoi est déclenché par le parent. */
defineProps<{ error: string; serverError: string; busy: string | null }>()
const model = defineModel<string>({ default: '' })
const emit = defineEmits<{ submit: []; request: []; clear: [] }>()
const field = ref<InstanceType<typeof CodeField> | null>(null)
onMounted(() => field.value?.focus())
</script>

<template>
  <form class="grid gap-4" novalidate @submit.prevent="emit('submit')">
    <p class="text-sm text-muted-foreground">
      Un code à 6 chiffres vous a été envoyé par e-mail. Il est valable 10 minutes.
    </p>
    <CodeField
      ref="field"
      v-model="model"
      label="Code reçu par e-mail"
      :digits="6"
      :error="error"
      @clear="emit('clear')"
    />
    <ErrorAlert :message="serverError" />
    <LoadingButton type="submit" class="w-full" :loading="busy === 'verify'">Vérifier</LoadingButton>
    <LoadingButton
      type="button"
      variant="link"
      size="sm"
      :loading="busy === 'request'"
      @click="emit('request')"
    >
      Renvoyer un code
    </LoadingButton>
  </form>
</template>
